import actionTypes from '../actionTypes';

export const alert = (type, msg) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ALERT_SHOW,
      payload: { type, msg },
    });
  };
};

export const hideAlert = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ALERT_HIDE,
    });
  };
};



// WEBPACK FOOTER //
// src/redux/actions/alert.js